export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 2_01.f7b6b146.jpg";